export const QAList = [
  "In what situations is surgery not suitable?",
  "Can I return to normal work after surgery?",
  "What if rejection occurs?",
  "What medications do I need to take after surgery? What are the side effects of these medications?",
  "Can I return to normal work after surgery?",
];
